import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { CoreModule } from '@bo-client/core';
import { SharedModule } from '@bo-client/shared';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PortalConfigurationPageComponent } from './portal-configuration-page/portal-configuration-page.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppMaterialModule } from '@bo-client/app.material.module';
import { LoaderInterceptor } from '@bo-client/core/interceptors/loader.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { ConfigModule } from '@bo-client/config/config.module';
import { ExternalRoutingModule } from '@bo-client/external.routing.module';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { AgGridModule } from 'ag-grid-angular';
import { LicenseManager } from 'ag-grid-enterprise';
import { QuillModule } from 'ngx-quill';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { AuthModule } from './shared/auth/auth.module';

LicenseManager.setLicenseKey(
  'Using_this_AG_Grid_Enterprise_key_( AG-039332 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Thuega SmartService GmbH )_is_granted_a_( Multiple Applications )_Developer_License_for_( 4 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_( 2 )_Production_Environments___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 3 May 2024 )____[v2]_MTcxNDY5MDgwMDAwMA==df6b81e10a6c2b9b686222eeeeefdafb'
);

registerLocaleData(localeDe, 'de-DE');

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    CoreModule,
    SharedModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    AppMaterialModule,
    ConfigModule.forRoot(),
    QuillModule.forRoot(),
    MonacoEditorModule.forRoot(),
    ExternalRoutingModule,
    AgGridModule,
    AuthModule
  ],
  declarations: [AppComponent, PageNotFoundComponent, PortalConfigurationPageComponent],
  providers: [
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
